import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownload = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M910.222 568.889v284.444c0 31.289-25.6 56.889-56.889 56.889h-682.667c-31.289 0-56.889-25.6-56.889-56.889v-284.444c0-31.289-25.6-56.889-56.889-56.889s-56.889 25.6-56.889 56.889v341.333c0 62.578 51.2 113.778 113.778 113.778h796.444c62.578 0 113.778-51.2 113.778-113.778v-341.333c0-31.289-25.6-56.889-56.889-56.889s-56.889 25.6-56.889 56.889zM568.889 550.116l106.951-106.951c22.187-22.187 58.027-22.187 80.213 0s22.187 58.027 0 80.213l-204.231 204.231c-22.187 22.187-58.027 22.187-80.213 0l-204.231-204.231c-22.187-22.187-22.187-58.027 0-80.213s58.027-22.187 80.213 0l107.52 106.951v-493.227c0-31.289 25.6-56.889 56.889-56.889s56.889 25.6 56.889 56.889v493.227z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgDownload);
export default ForwardRef;
